module.exports = __webpack_public_path__ + "static/media/playersYoupi.a6720828.png";